
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Carrentalserviceinpune() {



    const cardData =
    {
        keyword: 'Car Rental Service in Pune for Corporates',
        heading: 'etravo : Car Rental Service in Pune for Corporates',
        headingDescription: 'eTravo offers a trusted Car Rental Service in Pune for Corporates, designed to meet the travel demands of executives, business leaders, and company staff. Whether it’s for daily business commutes, airport transfers, client pickups, or event travel, our fleet of well-maintained sedans, SUVs, and luxury cars ensures a professional and comfortable experience. All vehicles are GPS-enabled and driven by courteous, trained chauffeurs, ensuring reliability and safety at every step. With flexible rental plans—hourly, daily, or monthly—eTravo is the preferred corporate car rental partner for companies across Pune’s growing commercial ecosystem.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "Car Rental Service in Pune for Corporates",
    "description": "eTravo offers a dependable car rental service in Pune for corporates, providing timely and professional transportation for employees, management, and clients across various industries and business zones."
  },
  {
    "name": "Corporate Car Hire Pune",
    "description": "With eTravo’s corporate car hire in Pune, companies can access premium vehicles and trained chauffeurs for executive movement, staff commutes, airport transfers, and client visits across the city."
  },
  {
    "name": "Reliable Business Car Rentals Pune",
    "description": "eTravo provides reliable business car rentals in Pune, ensuring punctual and safe transport for employees and executives. Our fleet includes hatchbacks, sedans, and premium cars for flexible use."
  },
  {
    "name": "Monthly Car Rentals Pune",
    "description": "Take advantage of eTravo’s monthly car rentals in Pune for corporate use. Ideal for long-term employee travel, fixed routes, and budget planning, our service ensures convenience and consistency."
  },
  {
    "name": "Staff Pickup and Drop Cars Pune",
    "description": "eTravo delivers efficient staff pickup and drop car services in Pune with optimized routes and real-time tracking. We ensure daily, safe, and timely commutes for office staff and shift workers."
  },
  {
    "name": "Executive Cab Services Pune",
    "description": "Travel in comfort and professionalism with eTravo’s executive cab services in Pune. Perfect for CXOs, senior management, and VIP guests requiring punctual and elegant corporate transport."
  },
  {
    "name": "Customized Transport for Companies Pune",
    "description": "eTravo offers customized transport for companies in Pune, tailored to employee strength, shift timings, office location, and business needs. Choose from dedicated corporate car options."
  },
  {
    "name": "Affordable Corporate Car Service Pune",
    "description": "eTravo delivers affordable corporate car service in Pune, helping companies manage transport costs without sacrificing reliability, safety, or comfort for their teams."
  },
  {
    "name": "AC Cars for Staff Transport Pune",
    "description": "Keep your team comfortable year-round with eTravo’s AC cars for staff transport in Pune. Our well-maintained, air-conditioned cars ensure smooth daily commutes in all weather conditions."
  },
  {
    "name": "End-to-End Corporate Car Mobility Pune",
    "description": "From booking to billing, eTravo provides end-to-end corporate car mobility in Pune. We handle scheduling, routing, support, and reporting to simplify your staff and executive transportation."
  },
  {
    "name": "Company Staff Commute Solutions Pune",
    "description": "Simplify daily employee travel with eTravo’s company staff commute solutions in Pune. We offer scalable options with GPS tracking, verified drivers, and 24/7 support for consistent service delivery."
  },
  {
    "name": "Business Meeting Car Rentals Pune",
    "description": "eTravo offers business meeting car rentals in Pune for quick and professional travel to meetings, seminars, and site visits. Our fleet ensures punctual arrivals and a professional image."
  },
  {
    "name": "Employee Movement Services Pune",
    "description": "Manage workforce mobility with eTravo’s employee movement services in Pune. We help businesses coordinate shift-based car travel, inter-office commutes, and project site transport smoothly."
  },
  {
    "name": "Industrial Area Car Rentals Pune",
    "description": "eTravo provides car rentals for industrial areas in Pune, covering MIDC zones and factory locations. Ideal for transporting supervisors, engineers, or small groups of staff safely and efficiently."
  },
  {
    "name": "Corporate Fleet Solutions Pune",
    "description": "eTravo’s corporate fleet solutions in Pune offer managed car services for employee and executive travel. From car allocation to reporting, we handle all aspects of fleet-based corporate mobility."
  }
],
"tableData": [
  ["Car Rental Service in Pune for Corporates", "Corporate Car Hire Pune"],
  ["Reliable Business Car Rentals Pune", "Monthly Car Rentals Pune"],
  ["Staff Pickup and Drop Cars Pune", "Executive Cab Services Pune"],
  ["Customized Transport for Companies Pune", "Affordable Corporate Car Service Pune"],
  ["AC Cars for Staff Transport Pune", "End-to-End Corporate Car Mobility Pune"],
  ["Company Staff Commute Solutions Pune", "Business Meeting Car Rentals Pune"],
  ["Employee Movement Services Pune", "Industrial Area Car Rentals Pune"],
  ["Corporate Fleet Solutions Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Trusted Car Rental Service for Corporates in Pune",
        "WhyChoosedescription": "eTravo provides reliable and professional car rental services tailored specifically for Pune’s corporate sector. Whether it’s for business meetings, airport transfers, or client visits, we ensure timely and comfortable travel."
    },
    {
        "WhyChooseheading": "Wide Selection of Corporate-Grade Vehicles",
        "WhyChoosedescription": "Our Pune fleet includes premium sedans, SUVs, and luxury cars maintained to the highest standards. Choose from daily rentals or long-term leasing options that suit your company’s unique requirements."
    },
    {
        "WhyChooseheading": "Professional Chauffeurs with Business Etiquette",
        "WhyChoosedescription": "All our drivers are background-verified, trained in corporate protocols, and possess deep knowledge of Pune’s key business districts such as Hinjewadi, Baner, and Kharadi, ensuring a seamless and respectful travel experience."
    },
    {
        "WhyChooseheading": "Flexible Rental Plans and Custom Packages",
        "WhyChoosedescription": "eTravo offers flexible rental durations and customized packages for companies of all sizes, from startups to large enterprises, making it easy to manage your corporate transportation needs."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We provide upfront, competitive pricing with GST-compliant invoices and detailed monthly billing statements to simplify financial management for your corporate travel expenses."
    },
    {
        "WhyChooseheading": "Safety and Comfort Are Our Priorities",
        "WhyChoosedescription": "Our vehicles are regularly serviced, sanitized, and equipped with modern safety features including GPS tracking, seat belts, and emergency kits to ensure a secure and comfortable ride for your executives and guests."
    },
    {
        "WhyChooseheading": "Real-Time Vehicle Tracking and 24/7 Support",
        "WhyChoosedescription": "Stay informed with live vehicle tracking and access our dedicated customer support team around the clock for booking assistance, route changes, or urgent travel requirements."
    },
    {
        "WhyChooseheading": "Seamless Integration with Your Corporate Policies",
        "WhyChoosedescription": "We work closely with your HR and admin teams to tailor our car rental services in Pune, ensuring compliance with your corporate travel policies and smooth coordination across all departments."
    }
]

















    }

const faqData = [
    [
        {
            question: 'What car rental services does eTravo offer for corporates in Pune?',
            answer: 'eTravo offers tailored car rental services in Pune for corporate use, including executive pickups, airport transfers, inter-city travel, and full-day rentals for meetings and audits.',
        },
        {
            question: 'Are cars available on both short-term and long-term rental plans in Pune?',
            answer: 'Yes, eTravo provides both short-term and long-term rental options in Pune, with flexible billing cycles to suit daily, weekly, or monthly corporate travel needs.',
        },
        {
            question: 'What vehicle categories are available for corporate rentals in Pune?',
            answer: 'Our Pune fleet includes hatchbacks, sedans, premium SUVs, and luxury cars — all chauffeur-driven and maintained to the highest standards of comfort and cleanliness.',
        },
        {
            question: 'Does eTravo provide professional chauffeurs with rental cars in Pune?',
            answer: 'Yes, all corporate car rentals in Pune come with well-trained, uniformed chauffeurs experienced in corporate protocol, punctuality, and city routes.',
        },
        {
            question: 'Do corporate clients in Pune get dedicated support for car rentals?',
            answer: 'Absolutely. Every corporate client is assigned a dedicated account manager who oversees scheduling, driver coordination, issue resolution, and service performance monitoring.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Alok Trivedi',
        designation: 'Admin Manager, SynerGen Labs, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s car rental service in Pune for all our corporate mobility needs. The vehicles are always in top condition, and the drivers are courteous and professional.”',
    },
    {
        name: 'Ms. Neha Phadke',
        designation: 'Executive Assistant, BlueOrbit Tech, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has been a trusted partner for our executive car rentals in Pune. The scheduling is flexible, support is responsive, and overall service quality is excellent.”',
    },
];
















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental Service in Pune for Corporates",
  "image": "https://www.etravo.in/images/keyword/car-rental-pune-corporate.jpg",
  "description": "Reliable car rental services in Pune for corporates offering executive car hire, monthly rentals, staff pickup and drop, AC cars for staff transport, and customized corporate mobility solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/car-rental-service-in-pune-for-corporates"
  }
};






    return (
        <div>
<Helmet>
  <title>Car Rental Service in Pune for Corporates | Executive & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire reliable car rental services in Pune for corporates with eTravo. Executive car hire, monthly rentals, staff pickup and drop, AC cars, and customized corporate transport solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/109.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Carrentalserviceinpune;